import { Component, Inject, ViewChild } from '@angular/core';
import { GenericDialogComponent } from '../generic-dialog/generic-dialog.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PayOdcManualCommand } from '@app/modules/management/command/odc-tesoreria.command';
import { DialogPaymentModel } from '@app/shared/models/dialog-payment.model';
import { PaymentService } from '@app/modules/management/services/payment.service';
import { HttpServerResponse } from '@app/core/models/response.model';
import { LoggerService } from '@app/core/services/logger.service';
import { ResponseStatus } from '@app/core/enums/response-status.enum';
import { AuthenticationService } from '@app/modules/authentication/services/authentication.service';
import { GenericGridComponent } from '../generic-grid/generic-grid.component';
const logger = new LoggerService('ModalPayOdcComponent');
@Component({
  selector: 'dhl-modal-pay-odc',
  templateUrl: './modal-pay-odc.component.html',
  styleUrls: ['./modal-pay-odc.component.scss']
})
export class ModalPayOdcComponent {
  dialogData: DialogPaymentModel;
  montoFormGroup: FormGroup;
  showModal: boolean = true;

  montoPattern = /^(\$)?\d{1,3}(?:,\d{3})*(?:\.\d{1,2})?$/;
  maxNumericCharacters = 250;
  isEqualsBalnce: boolean = false;

  @ViewChild('genericgrid') table!: GenericGridComponent<PayOdcManualCommand>;

  // Variable Globales para pagar un odc manual
  payOdcManualCommand: PayOdcManualCommand = {
    OrderId: 0,
    Balance: 0,
    Amount: 0,
    Reason: ''
  };

  constructor(public dialog: MatDialog,
    public dialogRef: MatDialogRef<GenericDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogPaymentModel, private readonly formBuilder: FormBuilder, public paymentservice: PaymentService, private readonly authenticationService: AuthenticationService,) {
    this.dialogData = data;
    this.montoFormGroup = this.formBuilder.group({
      monto: ['', [Validators.required, Validators.pattern(this.montoPattern)]],
      motivo: ['',[Validators.required, Validators.maxLength(250)] ]
    });
  }

  filterNumericInput(event: any) {
    const inputChar = String.fromCharCode(event.charCode);
    const numericValue = this.getNumericValue();
    if (!(/[0-9.]/.test(inputChar)) || numericValue.length >= this.maxNumericCharacters) {
      event.preventDefault();
    }
  }

  /**
   * On Accept dialog generic action
   */
  onAccept(): void {
    this.dialogRef.close(true);
  }

  // Modal Detalles motivo de pago
  showModalCarryInfo() {
    this.dialogRef.close(true);
    if (this.montoFormGroup.valid) {
      // Realizar acción deseada cuando ambos campos son válidos
      const dialogRef = this.dialog.open(GenericDialogComponent, {
        data: {
          title: 'Guardar información',
          message: `¿Esta seguro que desea guardar la información? Al continuar el saldo restante de la ODC se cubrirá y las guías serán liberadas. <strong> Esta acción no se puede cancelar una vez acepte.</strong> `,
          acceptLabel: 'Aceptar',
          showAccept: true,
          showCancel: true
        }
      });
      dialogRef.afterClosed().subscribe((result: boolean) => {
        if(result){
          const command: PayOdcManualCommand = {
            Amount: this.dialogData.Amount,
            Balance: this.dialogData.Balance,
            OrderId: this.dialogData.OrderId,
            Reason: this.montoFormGroup.get('motivo')?.value
          };
          this.callServiceCreateManualPay(command);

        }
      });
    }
  }

  callServiceCreateManualPay(command: PayOdcManualCommand){
    this.paymentservice.OdcPayment(command).subscribe({
      next: (response: HttpServerResponse<any>) => {
        if (response.status === ResponseStatus.Ok) {
          logger.info('ok');
          location.reload();
        }
      },
      error: (e) => {
        logger.error(e);
        this.authenticationService.validateLogued(e);
      },
      complete: () => {
        // This is intentional
      }
    });
  }

  /**
   * On Cancel dialog generic action
   */
  onCancel(): void {
    this.dialogRef.close(false);
  }

  private startModalInterval(): void {
    setTimeout(() => {
      this.showModal = true;
      this.showModalCarryInfo(); // Mostrar el modal automáticamente nuevamente
    }, 5000);
  }
  formatCurrencyInput() {
    const montoControl = this.montoFormGroup.controls['monto'];
    let value = montoControl.value;

    // Eliminar caracteres no numéricos
    value = value.replace(/[^\d.]/g, '');

    // Formatear el monto con comas y punto decimal
    const parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // Agregar signo de pesos al principio automáticamente
    if (parts.length > 1) {
      parts[1] = parts[1].substring(0, 2); // Limitar a dos decimales
      montoControl.setValue(`$${parts.join('.')}`);
    } else {
      montoControl.setValue(`$${parts[0]}`);
    }
    if(!(Number(value) == Number(this.data.saldo))){
      this.isEqualsBalnce = true;
    }else {
      this.isEqualsBalnce = false;
    }
  }
  private getNumericValue() {
    return this.montoFormGroup.controls['monto'].value.replace(/[^\d]/g, '');
  }
}
